import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../config/firebaseConfig';
import { useUserProfile } from '../contexts/UserProfileContext';
import { endPresenceSession } from './usePresenceHeartbeat';

/**
 * "Çıkış Yap": marks the user offline right away (see endPresenceSession),
 * signs out of Firebase and returns to the login page.
 */
const useSignOut = () => {
  const navigate = useNavigate();
  const { employeeId } = useUserProfile();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const signOutUser = useCallback(async () => {
    setIsSigningOut(true);
    try {
      await endPresenceSession(employeeId);
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
      setIsSigningOut(false);
    }
  }, [employeeId, navigate]);

  return { signOutUser, isSigningOut };
};

export default useSignOut;
